/**
 * Ground surface classification. Terrain exposes queries that return these;
 * Course/Hole data is what actually determines the classification at a
 * given point (see Terrain.setSurfaceTypeSampler). Terrain itself has no
 * opinion on what a "fairway" means beyond this label.
 */
export enum SurfaceType {
  Tee = 'tee',
  Fairway = 'fairway',
  Rough = 'rough',
  Green = 'green',
  Bunker = 'bunker',
  Water = 'water',
  OutOfBounds = 'out-of-bounds',
}
